import React from 'react'
import Swal from 'sweetalert2'
import axios from 'axios'

const DeleteActivity = (props) => {

    const delID = props.DelID
    const delTitle = props.DelTitle

    const handleDelete = () => {
        Swal.fire({
            title: 'Are you sure ?',
            text: `You want to delete - ${delTitle}`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: 'red',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Yes'
        }).then((result) => {
            if (result.isConfirmed) {
                axios.delete(`${process.env.REACT_APP_BASEURL}/activities/${delID}`)
                    .then(res => {
                        if (res.data.status === "Success") {
                            Swal.fire(
                                'Deleted!',
                                'Activity Deleted!',
                                'success'
                            )
                        }
                        else {
                            Swal.fire('Error!', '', 'error')
                        }
                    })
            }
        })
    }

    return (

        <>

            <div className="delete-icon">
                <i className="bi bi-trash3 btn-sm" onClick={handleDelete} />
            </div>

        </>

    )
}

export default DeleteActivity
